export enum OffenceComponentTypes {
  SocialCommunity = 'social_content',
  OffenceDetails = 'offence_details',
  DiscoverQuiz = 'discover_quiz_banner',
}
